import { useMemo } from 'react'

import { useFormContext, useWatch } from 'react-hook-form'
import { parseUnits } from 'viem'

import { TransferFormValues } from '~/components/forms/transfer/transferSchema'
import { SlippageTooltipContent } from '~/components/smart-accounts/SlippageTooltipContent'
import { useTokenMetadata } from '~/hooks/useTokenMetadata'
import { getSlippageAdjustedAmounts, percentageToBps } from '~/utils/swap'

export const SlippageTooltip = () => {
  const { control } = useFormContext<TransferFormValues>()

  const sellToken = useWatch({ control, name: 'swapData.sellToken' })

  const sellTokenMetadata = useTokenMetadata({
    address: sellToken?.token,
    chainId: sellToken?.chainId,
  })

  const slippage = useWatch({ control, name: 'swapData.slippage' })

  const slippageBps = useMemo(
    () => (slippage ? percentageToBps(Number(slippage)) : null),
    [slippage],
  )

  const { maximumAmountSpent } = useMemo(() => {
    if (
      !sellToken ||
      !sellTokenMetadata ||
      slippageBps === null ||
      !sellToken.amount
    ) {
      return { minimumReceived: null, maximumAmountSpent: null }
    }

    const parsedAmount = parseUnits(
      sellToken.amount,
      sellTokenMetadata.decimals ?? 18,
    )
    return getSlippageAdjustedAmounts(parsedAmount, slippageBps)
  }, [sellToken, sellTokenMetadata, slippageBps])

  if (!maximumAmountSpent || !sellToken)
    return 'The maximum price change you are willing to accept'

  return (
    <SlippageTooltipContent
      variant="max-spend"
      tokenAddress={sellToken.token}
      chainId={sellToken.chainId}
      amount={maximumAmountSpent}
    />
  )
}
